import { dew as _getChainIdDew } from "../../actions/public/getChainId.js";
import { dew as _addChainDew } from "../../actions/wallet/addChain.js";
import { dew as _deployContractDew } from "../../actions/wallet/deployContract.js";
import { dew as _getAddressesDew } from "../../actions/wallet/getAddresses.js";
import { dew as _getPermissionsDew } from "../../actions/wallet/getPermissions.js";
import { dew as _prepareTransactionRequestDew } from "../../actions/wallet/prepareTransactionRequest.js";
import { dew as _requestAddressesDew } from "../../actions/wallet/requestAddresses.js";
import { dew as _requestPermissionsDew } from "../../actions/wallet/requestPermissions.js";
import { dew as _sendRawTransactionDew } from "../../actions/wallet/sendRawTransaction.js";
import { dew as _sendTransactionDew } from "../../actions/wallet/sendTransaction.js";
import { dew as _signMessageDew } from "../../actions/wallet/signMessage.js";
import { dew as _signTransactionDew } from "../../actions/wallet/signTransaction.js";
import { dew as _signTypedDataDew } from "../../actions/wallet/signTypedData.js";
import { dew as _switchChainDew } from "../../actions/wallet/switchChain.js";
import { dew as _watchAssetDew } from "../../actions/wallet/watchAsset.js";
import { dew as _writeContractDew } from "../../actions/wallet/writeContract.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.walletActions = void 0;
  const getChainId_js_1 = _getChainIdDew();
  const addChain_js_1 = _addChainDew();
  const deployContract_js_1 = _deployContractDew();
  const getAddresses_js_1 = _getAddressesDew();
  const getPermissions_js_1 = _getPermissionsDew();
  const prepareTransactionRequest_js_1 = _prepareTransactionRequestDew();
  const requestAddresses_js_1 = _requestAddressesDew();
  const requestPermissions_js_1 = _requestPermissionsDew();
  const sendRawTransaction_js_1 = _sendRawTransactionDew();
  const sendTransaction_js_1 = _sendTransactionDew();
  const signMessage_js_1 = _signMessageDew();
  const signTransaction_js_1 = _signTransactionDew();
  const signTypedData_js_1 = _signTypedDataDew();
  const switchChain_js_1 = _switchChainDew();
  const watchAsset_js_1 = _watchAssetDew();
  const writeContract_js_1 = _writeContractDew();
  function walletActions(client) {
    return {
      addChain: args => (0, addChain_js_1.addChain)(client, args),
      deployContract: args => (0, deployContract_js_1.deployContract)(client, args),
      getAddresses: () => (0, getAddresses_js_1.getAddresses)(client),
      getChainId: () => (0, getChainId_js_1.getChainId)(client),
      getPermissions: () => (0, getPermissions_js_1.getPermissions)(client),
      prepareTransactionRequest: args => (0, prepareTransactionRequest_js_1.prepareTransactionRequest)(client, args),
      requestAddresses: () => (0, requestAddresses_js_1.requestAddresses)(client),
      requestPermissions: args => (0, requestPermissions_js_1.requestPermissions)(client, args),
      sendRawTransaction: args => (0, sendRawTransaction_js_1.sendRawTransaction)(client, args),
      sendTransaction: args => (0, sendTransaction_js_1.sendTransaction)(client, args),
      signMessage: args => (0, signMessage_js_1.signMessage)(client, args),
      signTransaction: args => (0, signTransaction_js_1.signTransaction)(client, args),
      signTypedData: args => (0, signTypedData_js_1.signTypedData)(client, args),
      switchChain: args => (0, switchChain_js_1.switchChain)(client, args),
      watchAsset: args => (0, watchAsset_js_1.watchAsset)(client, args),
      writeContract: args => (0, writeContract_js_1.writeContract)(client, args)
    };
  }
  exports.walletActions = walletActions;
  //# sourceMappingURL=wallet.js.map
  return exports;
}